module.exports = __webpack_public_path__ + "static/media/tags.1cffe851.svg";